class Game
{
    constructor() { }

    app: PIXI.Application;
    screenScale: number;
    uiContainer: PIXI.Container;
    staticContainer: PIXI.Container;
    dynamicContainer: PIXI.Container;
    textureFloor: PIXI.Texture;
    textureWall: PIXI.Texture;
    textureBox: PIXI.Texture;
    texturesMan: PIXI.Texture[];
    texturePos: PIXI.Texture;
    textLevel: PIXI.Text;
    textMove: PIXI.Text;
    mapDom: HTMLElement;
    mapIndex: number;
    mapCount: number;
    mapWidth: number = 18;
    mapHeight: number = 14;
    blockSize: number = 32;
    offsetX: number;
    offsetY: number;
    manX: number;
    manY: number;
    level:number;
    mapData: string[][];
    undoStack: string[];

    start()
    {
        // PIXI.settings.SCALE_MODE = PIXI.SCALE_MODES.NEAREST;
        
        var width = window.innerWidth;
        var height = window.innerHeight;
        if (height / width < 1.4)
            width = Math.round(height / 1.4);

        this.app = new PIXI.Application(innerWidth = width, innerHeight = height, { backgroundColor: 0x212121 });
        document.body.appendChild(this.app.view);
        this.app.view.style.position = 'absolute';
        this.app.view.style.left = ((document.body.clientWidth - width) / 2) + 'px';
        this.screenScale = this.app.screen.width / (this.blockSize * this.mapWidth);
        this.app.stage.scale.set(this.screenScale, this.screenScale);

        this.startGame();
    }

    startGame()
    {
        this.offsetX = 50;
        this.offsetY = 0;

        this.uiContainer = new PIXI.Container;
        this.app.stage.addChild(this.uiContainer);
        this.staticContainer = new PIXI.Container();
        this.app.stage.addChild(this.staticContainer);
        this.dynamicContainer = new PIXI.Container();
        this.app.stage.addChild(this.dynamicContainer);
        
        this.loadTextures();

        this.initUI();

        this.initMap();

        this.registerEvent();
    }

    registerEvent()
    {
        document.addEventListener('keydown', (e) => { this.onKeyDown(e); });
    }

    onKeyDown(e: KeyboardEvent)
    {
        if (e.keyCode == 37)//left
        {
            this.tryMove(-1, 0);
            var spriteMan = this.dynamicContainer.getChildByName('man') as PIXI.Sprite;
            spriteMan.texture = this.texturesMan[2];
        }
        else if (e.keyCode == 38)//up
        {
            this.tryMove(0, -1);
            var spriteMan = this.dynamicContainer.getChildByName('man') as PIXI.Sprite;
            spriteMan.texture = this.texturesMan[1];
        }
        else if (e.keyCode == 39)//right
        {
            this.tryMove(1, 0);
            var spriteMan = this.dynamicContainer.getChildByName('man') as PIXI.Sprite;
            spriteMan.texture = this.texturesMan[3];
        }
        else if (e.keyCode == 40)//down
        {
            this.tryMove(0, 1);
            var spriteMan = this.dynamicContainer.getChildByName('man') as PIXI.Sprite;
            spriteMan.texture = this.texturesMan[0];
        }
        else if (e.keyCode == 85)//U
        {
            this.tryUndo();
        }
        else if (e.keyCode == 82)//R
        {
            this.restart();
        }
    }

    loadTextures()
    {
        this.textureFloor = PIXI.Texture.fromImage('img/floor.png');
        this.textureWall = PIXI.Texture.fromImage('img/wall.png');
        this.textureBox = PIXI.Texture.fromImage('img/box.png');
        this.texturePos = PIXI.Texture.fromImage('img/pos.png');
        this.texturesMan = [];
        this.texturesMan[0] = PIXI.Texture.fromImage('img/front.png');
        this.texturesMan[1] = PIXI.Texture.fromImage('img/back.png');
        this.texturesMan[2] = PIXI.Texture.fromImage('img/left.png');
        this.texturesMan[3] = PIXI.Texture.fromImage('img/right.png');
    }

    initUI()
    {
        let sprite : PIXI.Sprite;

        sprite = new PIXI.Sprite(PIXI.Texture.fromImage('img/arrow_up.png'));
        sprite.position.set((this.app.screen.width / this.screenScale - 64) / 2, (this.app.screen.height / this.screenScale - 256));
        this.uiContainer.addChild(sprite);
        sprite.interactive = true;
        sprite.on('pointerdown', (e) =>
        {
            this.tryMove(0, -1);
            var spriteMan = this.dynamicContainer.getChildByName('man') as PIXI.Sprite;
            spriteMan.texture = this.texturesMan[1];
            (e.currentTarget as PIXI.Sprite).tint = 0xaaaaaa;
        });
        sprite.on('pointerup', (e) => { (e.currentTarget as PIXI.Sprite).tint = 0xffffff; });
        sprite.on('pointerupoutside', (e) => { (e.currentTarget as PIXI.Sprite).tint = 0xffffff; });

        sprite = new PIXI.Sprite(PIXI.Texture.fromImage('img/arrow_down.png'));
        sprite.position.set((this.app.screen.width / this.screenScale - 64) / 2, (this.app.screen.height / this.screenScale - 96));
        this.uiContainer.addChild(sprite);
        sprite.interactive = true;
        sprite.on('pointerdown', (e) => 
        {
            this.tryMove(0, 1);
            var spriteMan = this.dynamicContainer.getChildByName('man') as PIXI.Sprite;
            spriteMan.texture = this.texturesMan[0];
            (e.currentTarget as PIXI.Sprite).tint = 0xaaaaaa;
        });
        sprite.on('pointerup', (e) => { (e.currentTarget as PIXI.Sprite).tint = 0xffffff; });
        sprite.on('pointerupoutside', (e) => { (e.currentTarget as PIXI.Sprite).tint = 0xffffff; });
        
        sprite = new PIXI.Sprite(PIXI.Texture.fromImage('img/arrow_left.png'));
        sprite.position.set((this.app.screen.width / this.screenScale - 64) / 2 - 80, (this.app.screen.height / this.screenScale - 176));
        this.uiContainer.addChild(sprite);
        sprite.interactive = true;
        sprite.on('pointerdown', (e) =>
        {
            this.tryMove(-1, 0);
            var spriteMan = this.dynamicContainer.getChildByName('man') as PIXI.Sprite;
            spriteMan.texture = this.texturesMan[2];
            (e.currentTarget as PIXI.Sprite).tint = 0xaaaaaa;
        });
        sprite.on('pointerup', (e) => { (e.currentTarget as PIXI.Sprite).tint = 0xffffff; });
        sprite.on('pointerupoutside', (e) => { (e.currentTarget as PIXI.Sprite).tint = 0xffffff; });

        sprite = new PIXI.Sprite(PIXI.Texture.fromImage('img/arrow_right.png'));
        sprite.position.set((this.app.screen.width / this.screenScale - 64) / 2 + 80, (this.app.screen.height / this.screenScale - 176));
        this.uiContainer.addChild(sprite);
        sprite.interactive = true;
        sprite.on('pointerdown', (e) =>
        {
            this.tryMove(1, 0);
            var spriteMan = this.dynamicContainer.getChildByName('man') as PIXI.Sprite;
            spriteMan.texture = this.texturesMan[3];
            (e.currentTarget as PIXI.Sprite).tint = 0xaaaaaa;
        });
        sprite.on('pointerup', (e) => { (e.currentTarget as PIXI.Sprite).tint = 0xffffff; });
        sprite.on('pointerupoutside', (e) => { (e.currentTarget as PIXI.Sprite).tint = 0xffffff; });

        // let style = new PIXI.TextStyle({
        //     fontFamily: 'Arial',
        //     fontSize: 36,
        //     fontStyle: 'italic',
        //     fontWeight: 'bold',
        //     fill: ['#ffffff', '#00ff99'], // gradient
        //     stroke: '#4a1850',
        //     strokeThickness: 5,
        //     dropShadow: true,
        //     dropShadowColor: '#000000',
        //     dropShadowBlur: 4,
        //     dropShadowAngle: Math.PI / 6,
        //     dropShadowDistance: 6,
        //     wordWrap: true,
        //     wordWrapWidth: 440
        // });

        let style1 = new PIXI.TextStyle({
            fontFamily: 'Arial',
            fontSize: 32,
            fontWeight: 'bold',
            fill: '#ff4321'
        });

        this.textLevel = new PIXI.Text('LEVEL 1', style1);
        this.textLevel.x = 15;
        this.textLevel.y = 10;
        this.uiContainer.addChild(this.textLevel);

        this.textMove = new PIXI.Text('MOVE 0', style1);
        this.textMove.anchor.set(1, 0);
        this.textMove.x = this.app.screen.width / this.screenScale - 15;
        this.textMove.y = 10;
        this.uiContainer.addChild(this.textMove);

        let style2 = new PIXI.TextStyle({
            fontFamily: 'Arial',
            fontSize: 40,
            fontWeight: 'bold',
            fill: ['#ffffff', '#888888']
        });

        let text: PIXI.Text;

        text = new PIXI.Text('<LAST', style2);
        text.x = 15;
        text.y = this.offsetX + this.mapHeight * this.blockSize + 10;
        this.uiContainer.addChild(text);
        text.interactive = true;
        text.on('pointerdown', (e) => { this.loadLast(); });

        text = new PIXI.Text('NEXT>', style2);
        text.anchor.set(1, 0);
        text.x = this.app.screen.width / this.screenScale - 15;
        text.y = this.offsetX + this.mapHeight * this.blockSize + 10;
        this.uiContainer.addChild(text);
        text.interactive = true;
        text.on('pointerdown', (e) => { this.loadNext(); });

        text = new PIXI.Text('RESET', style2);
        text.x = 15;
        text.y = this.app.screen.height / this.screenScale - 72;
        this.uiContainer.addChild(text);
        text.interactive = true;
        text.on('pointerdown', (e) => { this.restart(); });

        text = new PIXI.Text('UNDO', style2);
        text.anchor.set(1, 0);
        text.x = this.app.screen.width / this.screenScale - 15;
        text.y = this.app.screen.height / this.screenScale - 72;
        this.uiContainer.addChild(text);
        text.interactive = true;
        text.on('pointerdown', (e) => { this.tryUndo(); });
    }

    initMap()
    {
        this.undoStack = [];

        this.mapIndex = 0;
        this.mapData = [];
        for(let y = 0; y < this.mapHeight; y++)
        {
            this.mapData[y] = [];
            for(let x = 0; x < this.mapWidth; x++)
            {
                this.mapData[y][x] = 'w';
            }
        }

        var req = new XMLHttpRequest();
        if (req != null)
        {
            req.open('GET', 'data/board.xml', true);
            req.onreadystatechange = () => 
            {
                if (req.readyState == 4)
                {
                    if(req.responseXML)
                    {
                        this.mapDom = req.responseXML.documentElement;
                        this.mapCount = this.mapDom.getElementsByTagName("deal").length;

                        var str = window.location.hash.substr(1);
                        var level = Number(str);
                        if (!isNaN(level) && level >= 0 && level < this.mapCount)
                            this.loadLevel(level);
                        else
                            this.loadLevel(0);
                    }
                    req.onreadystatechange = null;
                }
            };
            req.send(null);
        }
    }

    getMapData(x: number, y: number): string
    {
        return this.mapData[y][x];
    }

    setMapData(x: number, y: number, value: string)
    {
        this.mapData[y][x] = value;
    }

    loadMap(deal: string)
    {
        this.staticContainer.removeChildren();
        this.dynamicContainer.removeChildren();

        for (let y = 0; y < this.mapHeight; y++)
        {
            for (let x = 0; x < this.mapWidth; x++)
            {
                let sprite : PIXI.Sprite;

                if (deal[y * this.mapWidth + x] == 'w')
                {
                    sprite = new PIXI.Sprite(this.textureWall);
                    sprite.position.set(this.offsetY + x * this.blockSize, this.offsetX + y * this.blockSize);
                    this.staticContainer.addChild(sprite);
                }
                else if (deal[y * this.mapWidth + x] != '.')
                {
                    sprite = new PIXI.Sprite(this.textureFloor);
                    sprite.position.set(this.offsetY + x * this.blockSize, this.offsetX + y * this.blockSize);
                    this.staticContainer.addChild(sprite);
                }

                if (deal[y * this.mapWidth + x] == 'E')
                {
                    sprite = new PIXI.Sprite(this.texturePos);
                    sprite.position.set(this.offsetY + x * this.blockSize, this.offsetX + y * this.blockSize);
                    this.staticContainer.addChild(sprite);
                }
                else if (deal[y * this.mapWidth + x] == 'O')
                {
                    sprite = new PIXI.Sprite(this.texturePos);
                    sprite.position.set(this.offsetY + x * this.blockSize, this.offsetX + y * this.blockSize);
                    this.staticContainer.addChild(sprite);
                    sprite = new PIXI.Sprite(this.textureBox);
                    sprite.position.set(this.offsetY + x * this.blockSize, this.offsetX + y * this.blockSize);
                    sprite.name = 'box' + (y * this.mapWidth + x);
                    sprite.tint = 0xff6666;
                    this.dynamicContainer.addChild(sprite);
                }
                else if (deal[y * this.mapWidth + x] == 'o')
                {
                    sprite = new PIXI.Sprite(this.textureBox);
                    sprite.position.set(this.offsetY + x * this.blockSize, this.offsetX + y * this.blockSize);
                    sprite.name = 'box' + (y * this.mapWidth + x);
                    this.dynamicContainer.addChild(sprite);
                }
                else if (deal[y * this.mapWidth + x] == 'M')
                {
                    sprite = new PIXI.Sprite(this.texturePos);
                    sprite.position.set(this.offsetY + x * this.blockSize, this.offsetX + y * this.blockSize);
                    this.staticContainer.addChild(sprite);
                    sprite = new PIXI.Sprite(this.texturesMan[0]);
                    sprite.position.set(this.offsetY + x * this.blockSize, this.offsetX + y * this.blockSize);
                    sprite.name = 'man';
                    this.dynamicContainer.addChild(sprite);
                    this.manX = x;
                    this.manY = y;
                }
                else if (deal[y * this.mapWidth + x] == 'm')
                {
                    sprite = new PIXI.Sprite(this.texturesMan[0]);
                    sprite.position.set(this.offsetY + x * this.blockSize, this.offsetX + y * this.blockSize);
                    sprite.name = 'man';
                    this.dynamicContainer.addChild(sprite);
                    this.manX = x;
                    this.manY = y;
                }
                this.mapData[y][x] = deal[y * this.mapWidth + x];
            }
        }
    }

    tryMove(dx: number, dy: number)
    {
        var newx = this.manX + dx;
        var newy = this.manY + dy;
    
        if(newx < 0 || newx >= this.mapWidth || newy < 0 || newy >= this.mapHeight) return;
        switch(this.getMapData(newx, newy))
        {
            case 'e':
            case 'E':
                this.moveMan(newx, newy);
                break;
            case 'o':
            case 'O':
                var xx = newx + dx;
                var yy = newy + dy;
                if(xx < 0 || xx >= this.mapWidth || yy < 0 || yy >= this.mapHeight) return;
                var dest = this.getMapData(xx, yy);
                if(dest == 'e' || dest == 'E') {
                    this.pushUndo();
                    this.moveBox(newx, newy, xx, yy);
                    this.moveMan(newx, newy);
                    this.updateStatus();
                    this.checkGoal();
                }
                break;
        }
    }

    moveMan(x: number, y: number)
    {
        var value = this.getMapData(this.manX, this.manY);
	    this.setMapData(this.manX, this.manY, (value == 'm')? 'e' : 'E');
        this.manX = x;
        this.manY = y;
        var value = this.getMapData(this.manX, this.manY);
	    this.setMapData(this.manX, this.manY, (value == 'e')? 'm' : 'M');
        var spriteMan = this.dynamicContainer.getChildByName('man');
        spriteMan.position.set(this.offsetY + x * this.blockSize, this.offsetX + y * this.blockSize);
    }

    moveBox(fromX: number, fromY: number, toX: number, toY: number)
    {
        var value1 = this.getMapData(fromX, fromY);
	    this.setMapData(fromX, fromY, (value1 == 'o')? 'e' : 'E');
        var value2 = this.getMapData(toX, toY);
	    this.setMapData(toX, toY, (value2 == 'e')? 'o' : 'O');
        var spriteBox = this.dynamicContainer.getChildByName('box' + (fromY * this.mapWidth + fromX)) as PIXI.Sprite;
        spriteBox.name = 'box' + (toY * this.mapWidth + toX);
        spriteBox.position.set(this.offsetY + toX * this.blockSize, this.offsetX + toY * this.blockSize);
        spriteBox.tint = (value2 == 'e')? 0xffffff : 0xff6666;
    }

    pushUndo()
    {
        var board = '';
        for(let y = 0; y < this.mapHeight; y++)
        {
            for(let x = 0; x < this.mapWidth; x++)
            {
                var v = this.getMapData(x, y);
                board += v;
            }
        }
        this.undoStack[this.undoStack.length] = board;
    }

    tryUndo()
    {
        if(this.undoStack.length > 0) {
            this.loadMap(this.undoStack[this.undoStack.length - 1]);
            this.undoStack.length -= 1;
        }
        this.updateStatus();
    }

    updateStatus()
    {
        this.textLevel.text = 'LEVEL ' + this.mapIndex;
        this.textMove.text = 'MOVE ' + this.undoStack.length;
    }

    checkGoal()
    {
        for(let y = 0; y < this.mapHeight; y++)
        {
            for(let x = 0; x < this.mapWidth; x++)
            {
                if(this.getMapData(x, y) == 'o') return;
            }
        }
    
        this.loadNext();
    }

    restart()
    {
        this.loadLevel(this.mapIndex);
    }

    loadLast()
    {
        this.loadLevel(this.mapIndex - 1);
    }

    loadNext()
    {
        this.loadLevel(this.mapIndex + 1);
    }

    loadLevel(level: number)
    {
        this.mapIndex = (level + this.mapCount) % this.mapCount;
        this.loadMap(this.mapDom.getElementsByTagName("deal")[this.mapIndex].childNodes[0].nodeValue);
        this.undoStack = [];
        this.updateStatus();
    }
}

window.onload = () =>
{
    var game = new Game();
    game.start();
};
